import Nexfar from '../services/Nexfar';
import Masks from "../services/Masks";

export default {

    props: [],

    data: () => { return {
        showDistribuidorModal: false,
        showLoginModal: false,
        showRegisterModal: false,
        startValidation: false,
        cnpjValidated: false,
        registrationValidated: false,
        tokenValidated: false,
        loadingStateBtn: '',
        dateOfBirthFormated: '',
        registerIndex: 0,
        masks: Masks,
        registrationToken: '',
        genders: {
            'FEMALE': 'Feminino',
            'MALE': 'Masculino',
            'OTHER': 'Outro',
            'UNDEFINED': 'Prefiro não informar'
        },
        recommendationSource: {
            'SELLER': 'vendedor(a)',
            'WHATSAPP': 'Whatsapp',
            'EMAIL': 'Email',
            'SMS': 'SMS',
            'FLYER': 'Flyer',
            'OTHER': 'Outro'
        },
        loginValues: {
            email: '',
            password: ''
        },
        registerValues: {
            cnpj: '',
            cpf: '',
            name: '',
            email: '',
            phone: '',
            gender: '',
            recommendationSource: '',
            dateOfBirth: '',
            password: '',
            passwordConfirmation: ''
        }
    }},

    mounted: function() {


        let getModalTriggerDistribuidor = document.querySelector('a[href="#verdistribuidoras"]');
        if(getModalTriggerDistribuidor !== null) {
            getModalTriggerDistribuidor.addEventListener('click', function (){
                this.showDistribuidorModal = true;
            }.bind(this));
        }

        let getModalTriggerLogin = document.querySelectorAll('a[href="#entrar"]');
            getModalTriggerLogin.forEach(function (el){
                el.addEventListener('click', function (){
                    this.showLoginModal = true;
                }.bind(this));
            }.bind(this));

        let getModalTriggerRegister = document.querySelector('a[href="#cadastro"]');
        getModalTriggerRegister.addEventListener('click', function (){
            this.showRegisterModal = true;
        }.bind(this));

    },
    
    watch: {
        loginValues: {
            deep: true,
            handler: function (newValue, previousValue) {
                if(!this.startValidation) {
                    return;
                }
                this.formIsValid('login')
            }
        },
        registerValues: {
            deep: true,
            handler: function (newValue, previousValue) {
                if(!this.startValidation) {
                    return;
                }
                this.formIsValid('register')
            }
        },
    },

    methods: {
        loginSubmitForm: function (e) {
            e.preventDefault();
            this.startValidation = true;
            if (this.formIsValid('login')) {
                console.log('Do the login');
                this.loadingStateBtn = 'loading';
                Nexfar.login(this.formatInput(this.loginValues))
                    .then((data) => {
                        this.loadingStateBtn = '';
                        let errorField = document.getElementById('login-validation-error');
                        let fields = [
                            document.getElementById('login-fld-email'),
                            document.getElementById('login-fld-senha')
                        ]
                        if (data !== null && data.fieldErrors !== undefined) {
                            errorField.innerHTML = data.fieldErrors[0]['message'];
                            fields[0].classList.add('is-invalid');
                            fields[1].classList.add('is-invalid');
                        } else if(data === null) {
                            errorField.innerHTML = 'Erro ao fazer a busca';
                        } else {
                            fields[0].classList.add('is-valid');
                            fields[1].classList.add('is-valid');
                            this.loadingStateBtn = 'valid';

                            this.registerValues = this.formatInput(this.registerValues, true);

                            let loginRedirect = Nexfar.getLoginRedirectURL(data.token);
                            this.showLoginModal = false;
                            window.open(loginRedirect);
                        }

                    });
            }
            return false;
        },
        reSubmitRegistrationForm: function () {
            document.getElementById('registration-btn').click();
        },
        registrationSubmitForm: function (e) {
            e.preventDefault();
            this.startValidation = true;

            if (this.formIsValid('register')) {
                let self = this;
                this.loadingStateBtn = 'loading';
                Nexfar.registration(this.formatInput(this.registerValues))
                    .then(() => {
                        self.loadingStateBtn = '';
                        self.registrationValidated = true;
                        let mainErrorMessageBlock = document.getElementById('registration-message');
                            mainErrorMessageBlock.innerHTML = '';
                            mainErrorMessageBlock.classList.add('d-none');

                            self.registerIndex = 2;
                    })
                    .catch((err) => {

                        self.loadingStateBtn = '';
                        if (err.response.data === undefined) {
                            return;
                        }

                        if (err.response.data.fieldErrors !== undefined) {
                            Object.values(err.response.data.fieldErrors).forEach(function(error) {
                                if(error.field !== undefined) {
                                    let field = document.getElementById('registration-fld-' + error.field);
                                        if(field.innerHTML !== undefined) {
                                            if (field.parentNode.querySelector('.invalid-feedback') === null) {
                                                field.insertAdjacentHTML('afterend', '<div class="invalid-feedback">' + self.translateMessageOutput(error.message) + '</div>');
                                            }

                                            field.classList.remove('is-valid');
                                            field.classList.add('is-invalid');
                                        }
                                } else {
                                    let messager = document.getElementById('registration-message');
                                        messager.classList.add('d-block');

                                        if (error.message !== undefined) {
                                            messager.innerHTML = error.message;
                                        } else {
                                            messager.innerHTML = 'Usuário ja cadastrado';
                                        }
                                }
                            })
                        }
                    });
            }
            return false;
        },
        cnpjSubmitForm: function (e) {
            e.preventDefault();

            let field = document.getElementById('validate-fld-cnpj');

            if (field.value === '') {
                field.classList.add('is-invalid');
                return;
            }

            this.loadingStateBtn = 'loading';

            let formatedValues = this.formatInput(this.registerValues);
            Nexfar.validateCPNJ(formatedValues.cnpj)
                .then((data) => {
                    this.loadingStateBtn = '';
                    let errorField = document.getElementById('cnpj-validation-error');
                    errorField.innerHTML = '';

                    if (data !== null && data.fieldErrors !== undefined) {
                        errorField.innerHTML = data.fieldErrors[0]['message'];
                        field.classList.add('is-invalid');
                    } else if(data === null) {
                        errorField.innerHTML = 'Erro ao fazer a busca';
                        field.classList.add('is-invalid');
                    } else {
                        field.classList.remove('is-invalid');
                        field.classList.add('is-valid');
                        this.loadingStateBtn = 'valid';
                        this.endAnimationCNPJ();
                    }

                });
        },
        tokenSubmitForm: function (e) {
            e.preventDefault();

            let field = document.getElementById('registration-fld-token');
            let fieldMessage = document.getElementById('token-validation-error');

            if (field.value === '') {
                field.classList.add('is-invalid');
                return;
            }

            this.loadingStateBtn = 'loading';

            Nexfar.doRegistrationActivation(this.registrationToken)
                .then((data) => {

                    this.loadingStateBtn = '';

                    if (data.fieldErrors !== undefined) {
                        fieldMessage.innerHTML = 'Token não encontrado';
                        field.classList.add('is-invalid');
                        return;
                    }

                    field.classList.remove('is-invalid');
                    field.classList.add('is-valid');
                    this.tokenValidated = true;

                    this.registerValues = this.formatInput(this.registerValues, true);
                });
        },
        endAnimationCNPJ: function () {
            setTimeout(function (){
                this.cnpjValidated = true;
                this.registerIndex = 1;
                this.loadingStateBtn = '';
            }.bind(this),500);
        },
        formatInput: function (object, clear){
            let cleanValues = {};
            Object.keys(object).forEach(function(field){
                if (clear !== undefined) {
                    cleanValues[field] = '';
                } else {
                    if(object[field] !== '') {
                        cleanValues[field] = object[field];
                    }

                    if(field === 'cnpj' || field === 'cpf' || field === 'phone') {
                        cleanValues[field] = object[field].replaceAll('/', '')
                            .replaceAll('.', '')
                            .replaceAll('-', '')
                            .replaceAll('(', '')
                            .replaceAll(')', '')
                            .replaceAll(' ', '');
                    }

                    if(field === 'dateOfBirth') {
                        let dateParts = object[field].split('-');
                        cleanValues[field] = dateParts[2] + dateParts[1] + dateParts[0] + '000000';
                    }
                }


            }.bind(this));
            return cleanValues;
        },
        translateMessageOutput: function (messageString) {
            if(messageString === 'CPF.transientUserActivate.cpf') { return 'CPF Inválido'}
            if(messageString === 'Size.transientUserActivate.phone') { return 'Faltam dígitos no campo telefone'}
            return "";
        },
        formIsValid: function(type) {

            let errorCount = 0;
            let form = null;
            let fieldsToCheck = {};

            if (type === 'register') {
                form = document.getElementById('registration-form');
                fieldsToCheck = this.registerValues;
            }

            if (type === 'login') {
                form = document.getElementById('login-form');
                fieldsToCheck = this.loginValues;
            }

            if (form === null) {
                console.log('Cant find form!');
                 return false;
            }

            Object.keys(fieldsToCheck).forEach(function(field){
                let input = form.querySelector('input[name="'+field+'"]');
                if (input !== null) {
                    input.classList = 'form-control';
                    if (input.getAttribute('rel') !== 'not-required') {
                        if (fieldsToCheck[field] === '') {
                            errorCount++;
                            input.classList.add('is-invalid');
                        } else {
                            input.classList.add('is-valid');
                        }
                    }

                    if (field.indexOf('Confirmation') !== -1) {
                        if (fieldsToCheck[field] !== fieldsToCheck[field.replace('Confirmation', '')]) {
                            errorCount++;
                            input.classList.remove('is-valid');
                            input.classList.add('is-invalid');

                            let fieldToConfirm = document.getElementById(field + 'confirm-password-validation-error');

                            if(fieldToConfirm !== undefined) {
                                let fieldValidMessage = document.getElementById(field + 'confirm-password-validation-error');
                                if (fieldValidMessage.innerHTML !== undefined) {
                                    fieldValidMessage.innerHTML = 'Precisam ser iguais!';
                                }
                            }
                        }
                    }
                } else {

                    let formField = form.querySelector('button#registration-fld-' + field);
                    if (fieldsToCheck[field] === '') {
                        errorCount++;

                        if (formField !== null) {
                            formField.parentNode.classList.add('is-invalid');
                        } else {
                            let formField = form.querySelector('label[for="registration-fld-' + field + '"]').parentNode;
                            let allInputs = formField.querySelectorAll('.custom-control-input');
                            allInputs.forEach(function(item){
                                item.classList.add('is-invalid');
                            });
                        }

                    } else {

                        if (formField !== null) {
                            formField.parentNode.classList.add('is-valid');
                        } else {
                            let formField = form.querySelector('label[for="registration-fld-' + field + '"]').parentNode;
                            let allInputs = formField.querySelectorAll('.custom-control-input');
                            allInputs.forEach(function(item){
                                item.classList.add('is-valid');
                            });
                        }
                    }


                }
            }.bind(this));

            if (errorCount === 0) {
                form.classList.add('was-validated');
            }

            return errorCount === 0;
        },
        formatDateBirthSelect: function (value) {
            if (value.selectedDate !== null) {
                let dateValues = value.selectedYMD.split('-');
                this.dateOfBirthFormated = dateValues[2] + '/' + dateValues[1] + '/' + dateValues[0]
            }
        },
        formatDateBirthOnType: function (e) {
            if (e !== '') {
                let value = e.target.value;
                let dateValues = value.split('/');

                if (window.typeTime !== undefined) {
                    clearTimeout(window.typeTime);
                }

                window.typeTime = setTimeout(function(e){
                    this.registerValues.dateOfBirth = dateValues[2] + '-' + dateValues[1] + '-' + dateValues[0];
                }.bind(this),500);

            }
        },
        toggleLoginModal: function () {
            this.showRegisterModal = false;
            this.showLoginModal = true;
        }

    }

}
